var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"font-weight-medium",attrs:{"absolute":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" Copyright "+_vm._s(new Date().getFullYear())+" - powered by AutoSyncX™ - All Rights Reserved ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }